/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/play': {
    width: 10,
    height: 16,
    viewBox: '0 0 10 16',
    data: '<path pid="0" _fill="#fff" d="M10 8L0 16V0l10 8z"/>'
  }
})
